export const AttachmentTypes = {
  LINK: 'LINK',
  MEDIA: 'MEDIA',
  RETWEET: 'RETWEET',
  REELS: 'REELS',
} as const;

export const MediaAttachmentTypes = {
  WEBM: 'WEBM',
  JPG: 'JPG',
  JPEG: 'JPEG',
  PNG: 'PNG',
  GIF: 'GIF',
  AVI: 'AVI',
  MP4: 'MP4',
  M4V: 'M4V',
  MOV: 'MOV',
  WEBP: 'WEBP',
  MPG: 'MPG',
  MPEG: 'MPEG',
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
} as const;

export const ImageDimensions = {
  large: {
    width: 306,
    height: 544,
  },
  regular: {
    width: 180,
    height: 320,
  },
  thumbnail: {
    width: 110,
    height: 198,
  },
} as const;

export const UploadTypes = {
  LINK_THUMBNAIL: 'LINK_THUMBNAIL',
  MEDIA: 'MEDIA',
} as const;

export const MediaTypes = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  GIF: 'GIF',
} as const;
